import Nav from '../../globalComponents/nav/Nav';
import Footer from '../../globalComponents/footer/Footer';
import './viewProject.css'
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { MDBBtn, MDBAccordion, MDBAccordionItem } from 'mdb-react-ui-kit';
import Modal from 'react-modal';
import Url from '../url'

function ViewProject() {
    
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width:"auto",
            maxWidth: "90vw",
            height: "auto",
            maxHeight:"80vh",
            border:"none",
            background:"none",
            transform: 'translate(-50%, -50%)',
            overflow: "hidden"

        },
    };
    
    const [modalIsOpen, setIsOpen] = useState(false);

    let { id } = useParams()
    const [ imageDisplay, setImageDisplay ] = useState(false)

    const navigate = useNavigate()
    const { projectId } = useParams()
    const [originalProject, setOriginalProject] = useState({})
    
    //const [ projectId, setProjectId ] = useState()
    const [token, setToken] = useState(null)
    const [currentUserEmail, setCurrentUserEmail] = useState(undefined)
    const [admin, setAdmin] = useState(null)
    const [projectsLoaded, setProjectsLoaded] = useState(false)
    const [displayProjects, setDisplayProjects] = useState(false)
    const [tokenLoaded, setTokenLoaded] = useState(false)
    const [currentUserId, setCurrentUserId] = useState(undefined)
    const [projects, setProjects] = useState(null)

    //** Project info below */
    const [projectName, setProjectName] = useState("")

    const [projectDescription, setProjectDescription] = useState("")
    const [imageOfTheProject, setImageOfTheProject] = useState()

    const [nameOfOriginalCreator, setNameOfOriginalCreator] = useState("")
    const [originalCreatorPhoto, setOriginalCreatorPhoto] = useState()

    const [projectType, setProjectType] = useState("")
    const [projectTypeOther, setProjectTypeOther] = useState("other")

    const [material, setMaterial] = useState("")
    const [pictureOfMaterial, setPictureOfMaterial] = useState()

    const [typeOfWork, setTypeOfWork] = useState("")
    const [typeOfWorkOther, setTypeOfWorkOther] = useState("other")

    const [projectReciever, setProjectReciever] = useState("")

    const [printedPattern, setPrintedPattern] = useState(false)
    const [printedPatternPicture, setPrintedPatternPicture] = useState()

    const [smokerOK, setSmokerOK] = useState(false)

    const [projectStatus, setProjectStatus] = useState("")

    const [disclaimer, setDisclaimer] = useState(false)

    const [foundUser, setFoundUser] = useState({})

    const [buttonDisabled, setButtonDisabled ] = useState()
    
    useEffect(() => {
        if (localStorage.getItem("user")) {

            setCurrentUserEmail(localStorage.getItem("user"))
            localStorage.getItem("token")[3] == "Y" ? setAdmin(true) : setAdmin(false)
            setToken(localStorage.getItem("token").slice(0, 3) + localStorage.getItem("token").slice(4))
            setTokenLoaded(true)
            checkStatus()
            // projectStatus === "pending" ? setButtonDisabled(true) : setButtonDisabled(false)
        }
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0)
        
    },[])


    const claimAction = e => {
        console.log(token)
        if (tokenLoaded) {
            console.log("hit past token loaded")
            console.log(projectId)

            fetch(Url+'project/updateProjectStatus', {
                method: "POST",
                body:
                    JSON.stringify({ status: "pending", projectId: projectId })
                ,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })
            })
                .then(res => res.json())
                .then(data => {
                    console.log(data)
                    if(data.error) {
                        
                        alert(data.error)
                    } else {
                        console.log("Data here", data)
                        setDisplayProjects(true)
                        navigate('/myProjects')
                    }
                    
                    
                    console.log(projectStatus)
                })
                
                .catch(err => console.log(err))
        }
    }

    const checkStatus = () => {
        if(projectStatus === "pending"){
            setButtonDisabled(true)
        }
    }

    const conditionalRender = () => {
        return (
            <>
                {

                    tokenLoaded ? 

                    <div className='row shadow-5-strong pt-4' style={{ textAlign: "center", marginTop: "3rem" }}>
                        <div className='col-md-8'>
                            <p><strong>Email: </strong>{foundUser.email}</p>
                            <hr id='host-detail-hr'></hr>
                            <p ><strong>Location: </strong>{
                                
                                foundUser.country && foundUser.country =="us" 
                                    ?  `United States ${foundUser.state ? "/ "+foundUser.state : null}` 
                                    : foundUser.country
                                }</p>
                            <hr id='host-detail-hr'></hr>
                            <p><strong>Host Name: </strong>{foundUser.fName + " " + foundUser.lName}</p>
                            
                        </div>
                        
                        <div className='col'>
                        <small><b>Note: </b></small>We limit one project per volunteer.
                        </div>
                        <div className='col' style={{ display: "flex", alignItems: "bottom" }}>
                        
                        {
                            projectStatus === "pending" || projectStatus === "claimed" ? <MDBBtn disabled='true' className='claim-project-button'
                                onClick={() => {
                                    { claimAction() }
                                    
                                }}
                            >{projectStatus}</MDBBtn> : <MDBBtn className='claim-project-button'
                            onClick={() => {
                                { claimAction() }
                                
                            }}
                        >{projectStatus}</MDBBtn>
                        }
                            
                        </div>

                    </div> : null
                }
            </>
        )

    }

    useEffect(() => {
        if (token && !projectsLoaded) {
            console.log(`fetching with token ` + token)
            console.log(`projectId: ` + projectId)
            fetch(Url+`project/projectInfo/${projectId}`, {
                method: "GET",
                body: null,
                headers: new Headers({
                    "Content-Type": "application/json",
                    "authorization": token
                })

            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        alert(`${data.error}`)
                    }
                    else {
                        console.log(data)
                        setProjectsLoaded(true)
                        
                        //save original project info 
                        setOriginalProject(data.foundProject)
                        setFoundUser(data.foundUser)
                        //assign all values from data to the fields
                        setProjectName(data.foundProject.projectName)
                        setProjectDescription(data.foundProject.projectDescription)
                        setImageOfTheProject(data.foundProject.imageOfTheProject)

                        setNameOfOriginalCreator(data.foundProject.nameOfOriginalCreator)
                        setOriginalCreatorPhoto(data.foundProject.originalCreatorPhoto)
                        setProjectReciever(data.foundProject.projectReciever)

                        setProjectType(data.foundProject.projectType)
                        setMaterial(data.foundProject.material)
                        setPictureOfMaterial(data.foundProject.pictureOfMaterial)

                        setTypeOfWork(data.foundProject.typeOfWork)
                        setPrintedPattern(data.foundProject.printedPattern)
                        setPrintedPatternPicture(data.foundProject.printedPatternPicture)

                        setSmokerOK(data.foundProject.smokerOK)
                        setProjectStatus(data.foundProject.status)

                    }
                })
                .catch(err => { console.log(err) })
        }
        else if(!projectsLoaded){
            fetch(Url+`guest/guestProjectInfo/${projectId}`, {
                method: "GET",
                body: null,
                headers: new Headers({
                    "Content-Type": "application/json",
                    
                })

            })
                .then(res => res.json())
                .then(data => {
                    if (data.error) {
                        alert(`${data.error}`)
                    }
                    else {
                        console.log(data)
                        setProjectsLoaded(true)
                        //save original project info 
                        setOriginalProject(data.foundProject)
                        
                        setProjectName(data.foundProject.projectName)
                        setProjectDescription(data.foundProject.projectDescription)
                        setImageOfTheProject(data.foundProject.imageOfTheProject)

                        setNameOfOriginalCreator(data.foundProject.nameOfOriginalCreator)
                        setOriginalCreatorPhoto(data.foundProject.originalCreatorPhoto)
                        setProjectReciever(data.foundProject.projectReciever)

                        setProjectType(data.foundProject.projectType)
                        setMaterial(data.foundProject.material)
                        setPictureOfMaterial(data.foundProject.pictureOfMaterial)

                        setTypeOfWork(data.foundProject.typeOfWork)
                        setPrintedPattern(data.foundProject.printedPattern)
                        setPrintedPatternPicture(data.foundProject.printedPatternPicture)

                        setSmokerOK(data.foundProject.smokerOK)
                        setProjectStatus(data.foundProject.status)

                    }
                })
                .catch(err => { console.log(err) })
        }

    }, [token])

    let subtitle;
    function openModal(e) {
        setImageDisplay(e)
        setIsOpen(true);
    }
    
    function afterOpenModal() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = 'white';
    }
    
    function closeModal() {
        setIsOpen(false);
        }

    
    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                ariaHideApp={false}
                contentLabel="Example Modal">
                    <div className='container'>
                        <div className='row-lg'>
                            <button className="btn btn-primary" ref={(_subtitle) => (subtitle = _subtitle)} onClick={closeModal}>x</button>
                        </div>
                        <div className='col'>
                            <img src={imageDisplay} alt="" className= "img-thumbnail" />
                        </div>
                    </div>
            </Modal>

            <Nav></Nav>
            <div id="main" className='container-sm' style={{ marginTop: "120px" }}>
                <div className='row shadow-5-strong pb-4 pt-4'>
                    <div className='col-md-5'>
                        <div className='col-md-12' >
                            { imageOfTheProject &&
                            <img className='custom-img' src={imageOfTheProject} alt="" onClick={e=>openModal(e.target.src)} />
                            }

                            { originalCreatorPhoto &&
                                <>
                                <img id ="creatorImage" className='custom-img' src={originalCreatorPhoto} onClick={e=>openModal(e.target.src)} alt="" />
                                </>
                            }
                            { pictureOfMaterial &&
                                <>
                                <img id ="materialImage" className='custom-img' src={pictureOfMaterial} onClick={e=>openModal(e.target.src)} alt="" />
                                </>
                            }
                            </div>
                    </div>

                    <div className='col' style={{ textAlign: "center" , marginTop:"2rem"}}>
                        <h5 style={{fontWeight:"bold"}}>Project Name</h5>
                        <h6>{projectName}</h6>
                        <hr></hr>
                        <h5 style={{fontWeight:"bold"}}>Project Description</h5>
                        <h6>{projectDescription}</h6>
                        <hr></hr>
                        <h5 style={{fontWeight:"bold"}}>Project Type</h5>
                        <h6>{projectType}</h6>
                        <hr></hr>
                        <h5 style={{fontWeight:"bold"}}>Type of Work</h5>
                        <h6>{typeOfWork}</h6>
                        
                    </div>
                </div>

                {conditionalRender()}

            </div>
            <div style={{marginTop:"100px"}}/>
            
            <Footer></Footer>
        </>
    )
}

export default ViewProject